import { Component } from '@angular/core';
import { Platform, NavController, NavParams } from 'ionic-angular';

import { AppVersion } from '@ionic-native/app-version'
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-download-latest-version',
  templateUrl: 'download-latest-version.html',
})
export class DownloadLatestVersionPage {
	appVersionPrint: any = "1.0";

	constructor(
		public platform: Platform, 
		public appVersion: AppVersion,
		public navCtrl: NavController, 
		public navParams: NavParams,
		private iab: InAppBrowser) {

		platform.ready().then((readySource) => {
	        if(readySource!="dom"){
				this.appVersion.getVersionNumber().then((version)=> {
		    		this.appVersionPrint = version;
				});	          
	        }
		});		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad DownloadLatestVersionPage');
	}

	gotoStore(){
		var url = "https://itunes.apple.com/us/app/bumerang/id1358713027?mt=8";
		
	    if (this.platform.is('android')){
	   		console.log('I am an Android device!');

	   		url = "https://play.google.com/store/apps/details?id=com.brokenbay.bumerang&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";
	    }		

		let browser = this.iab.create(url, "_self", {  closebuttoncaption: "Cerrar" });

		browser.show();
	}
}



// WEBPACK FOOTER //
// ./src/pages/download-latest-version/download-latest-version.ts